import React from 'react';
import { IconSvgProps } from '@models/common';

const Gemini: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.1247 5.87531C13.0791 6.82875 14.1909 7.57875 15.4622 8.12625C15.9506 8.33625 16.4503 8.505 16.9641 8.63437C17.1319 8.67656 17.25 8.82656 17.25 9C17.2498 9.08407 17.2216 9.16568 17.1698 9.2319C17.118 9.29812 17.0456 9.34518 16.9641 9.36563C16.4503 9.495 15.9497 9.66375 15.4622 9.87375C14.1909 10.4203 13.0781 11.1713 12.1247 12.1247C11.1713 13.0791 10.4213 14.1909 9.87375 15.4622C9.66375 15.9506 9.495 16.4503 9.36563 16.9641C9.32344 17.1319 9.17344 17.25 9 17.25C8.91593 17.2498 8.83432 17.2216 8.7681 17.1698C8.70188 17.118 8.65482 17.0456 8.63437 16.9641C8.505 16.4503 8.33625 15.9497 8.12625 15.4622C7.57969 14.1909 6.82875 13.0781 5.87531 12.1247C4.92094 11.1713 3.80906 10.4213 2.53781 9.87375C2.04937 9.66375 1.54969 9.495 1.03594 9.36563C0.868125 9.32344 0.75 9.17344 0.75 9C0.75 8.82656 0.868125 8.67656 1.03594 8.63437C1.54969 8.505 2.05125 8.33531 2.53781 8.12625C3.80906 7.57875 4.92188 6.82781 5.87531 5.87531C6.82875 4.92188 7.57875 3.80906 8.12625 2.53781C8.33625 2.04937 8.505 1.54969 8.63437 1.03594C8.67656 0.868125 8.82656 0.75 9 0.75C9.17344 0.75 9.32344 0.868125 9.36563 1.03594C9.495 1.54969 9.66469 2.05125 9.87375 2.53781C10.4203 3.80906 11.1713 4.92188 12.1247 5.87531Z'
        fill='url(#gemini-gradient)'
      />
      <defs>
        <linearGradient
          id='gemini-gradient'
          x1='0.75'
          x2='17.25'
          y1='17.25'
          y2='0.75'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#FAE089' />
          <stop
            offset='.28'
            stopColor='#35AA9E'
          />
          <stop
            offset='.58'
            stopColor='#3287FE'
          />
          <stop
            offset='.82'
            stopColor='#B96A95'
          />
          <stop
            offset='1'
            stopColor='#FCA2A2'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Gemini;
